/* rd-bookings — visual-only glass back button (design D6). The 44×44 square,
   13px radius, accent-tinted border, and white arrow are the treatment shared by
   the four shipped flow pages; positioning is supplied by each consumer's own
   class. Copied from the shipped PaymentPage.module.css `.back` (visual half). */
.back {
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid rgba(var(--accent-rgb), 0.3);
  width: 44px;
  height: 44px;
  border-radius: 13px;
  background: var(--glass-bg-strong);
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-shadow);
  color: var(--chevron-color);
  display: grid;
  place-items: center;
}
.back:disabled {
  opacity: 0.55;
}
.back svg {
  width: 19px;
  height: 19px;
  stroke-width: 2.6;
}
